import React from "react";
import EACombobox from "../EACombobox";
import EAFieldset from "../EAFieldset";

export default function PersonalisierungsFilterFieldSet({
                                                            values,
                                                            setValues,
                                                            betriebstypen,
                                                            anlagentypen,
                                                            messstellentyp,
                                                            verwaltungseinheit,
                                                        }) {

    return (
        <EAFieldset caption="Filter">
            <div id="Filter" className="gridl">
                <EACombobox
                    id={"betriebstypFilter"}
                    value={values.betriebstyp ? values.betriebstyp : null}
                    onChange={(_e, newValue) => setValues({...values, betriebstyp: newValue})}
                    label="Betriebstyp"
                    options={betriebstypen?.data}
                    loading={betriebstypen?.loading}
                    optionTitle="value"
                    optionKey="id"
                />
                <EACombobox
                    id={"anlagentypFilter"}
                    value={values.anlagentyp ? values.anlagentyp : null}
                    onChange={(_e, newValue) => setValues({...values, anlagentyp: newValue})}
                    label="Anlagentyp"
                    options={anlagentypen?.data}
                    loading={anlagentypen?.loading}
                    optionTitle="value"
                    optionKey="id"
                />
                <EACombobox
                    id={"messstellentypFilter"}
                    value={values.messstellentyp ? values.messstellentyp : null}
                    onChange={(_e, newValue) => setValues({...values, messstellentyp: newValue})}
                    label="Messstellentyp"
                    options={messstellentyp?.data}
                    loading={messstellentyp?.loading}
                    optionTitle="value"
                    optionKey="id"
                />
                <EACombobox
                    id={"verwaltungseinheitFilter"}
                    value={values.verwaltungseinheit ? values.verwaltungseinheit : null}
                    onChange={(_e, newValue) => setValues({...values, verwaltungseinheit: newValue})}
                    label="Räumliches Kriterium"
                    options={verwaltungseinheit?.data}
                    loading={verwaltungseinheit?.loading}
                    optionTitle="value"
                    optionKey="verwaltungseinheit"
                />
            </div>
        </EAFieldset>
    );
}
